import { Component, Input, OnInit, input, inject } from '@angular/core';
import { Form } from '../../data/form';
import { UtilService } from '../../services/util.service';
import { Process } from '../../data/process';
import { ProcessField } from '../../data/process-field';
import { ActionType } from '../../types/action-type';
import { OrgUnitType } from '../../types/org-unit-type';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css'],
  imports: [DatePipe]
})
export class PrivacyPolicyComponent implements OnInit {
  utilService = inject(UtilService);

  @Input() form: Form | undefined;
  readonly process = input<Process>();

  ngOnInit(): void {
    const process = this.process();
    if (!this.form && process) {
      this.form = new Form();
      this.form.id = process.formId;
      this.form.name = process.formName;
      this.form.fields = process.fields?.map((field: ProcessField) => field.formField).filter(field => !!field);
      this.form.timestamp = process.formTimestamp;
      this.form.orgUnitType = process.formOrgUnitType;
      this.form.contactEmail = process.formContactEmail;
      this.form.contactTelephone = process.formContactTelephone;
      this.form.orgUnitName = process.formOrgUnitName;
      this.form.privacyReason = process.formPrivacyReason;
      this.form.dataFields = process.formDataFields;
      this.form.legalBasis = process.formLegalBasis;
      this.form.dataTransmission = process.formDataTransmission;
      this.form.externalDataTransmission = process.formExternalDataTransmission;
      this.form.storagePeriod = process.formStoragePeriod;
    }
  }

  checkTypeInField(type: string): boolean {
    if (this.form?.fields) {
      for (const field of this.form.fields) {
        if (field.type && field.type === type) {
          return true;
        }
      }
    }
    return false;
  }

  checkTypeInApprover(type: string): boolean {
    if (this.form?.approverTypes) {
      for (const field of this.form.approverTypes) {
        if (field && field === type) {
          return true;
        }
      }
    }
    return false;
  }

  prepareLink(s: string | null | undefined): string | null | undefined {
    return s ? this.utilService.prepareLink(s) : '';
  }

  protected readonly ActionType = ActionType;
  protected readonly OrgUnitType = OrgUnitType;
}
